import {Routes} from '@angular/router';

export const combinationRecommendationRoutes: Routes = [
  {
    path: 'combinationRecommendation',
    loadComponent: () => import('./combination-recommendation.component').then(m => m.CombinationRecommendationComponent),
    data: { title: '拼套装橱窗' },
  },
];
